import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Seo } from "../../components/public/Seo";
import { QuoteForm } from "../../components/public/QuoteForm";
import { COMPANY } from "../../lib/api";

export default function Contact() {
  return (
    <>
      <Seo title="Contact / Get a Quote" description="Get a free roofing quote from West Face Roofing. Call 08 9247 2962 or send us your details — we'll call you back within the hour. Perth, WA." path="/contact" />
      <section className="pt-32 md:pt-44 pb-12 bg-[#224733] text-white relative overflow-hidden wf-grain">
        <div className="absolute -bottom-32 -left-32 w-[480px] h-[480px] rounded-full bg-[#62B848]/15 blur-3xl" />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
          <p className="text-[#62B848] font-bold tracking-wide uppercase text-sm mb-4">Get in touch</p>
          <h1 className="font-display font-black tracking-tight text-5xl sm:text-6xl lg:text-7xl leading-none max-w-3xl text-balance">Get your free quote.</h1>
          <p className="mt-6 text-white/70 text-lg max-w-xl leading-relaxed">Tell us about the job and we'll call you back within the hour. Prefer to talk now? Give us a ring.</p>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-[#F8F9FA]">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-[1fr_1.1fr] gap-12">
          <div>
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {[
                { icon: Phone, label: "Call us", value: COMPANY.phone, href: COMPANY.phoneHref },
                { icon: Mail, label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}` },
                { icon: MapPin, label: "Based in", value: COMPANY.address },
                { icon: Clock, label: "Hours", value: COMPANY.hours },
              ].map((c) => (
                <div key={c.label} className="bg-white rounded-3xl border border-black/5 p-6">
                  <div className="grid place-items-center w-12 h-12 rounded-2xl bg-[#224733]/8 text-[#224733] mb-4"><c.icon size={22} /></div>
                  <div className="text-xs uppercase tracking-wide text-[#4A5550] font-bold mb-1">{c.label}</div>
                  {c.href ? <a href={c.href} className="font-display font-bold text-[#1A2421] hover:text-[#62B848] transition-colors break-words">{c.value}</a>
                    : <div className="font-display font-bold text-[#1A2421]">{c.value}</div>}
                </div>
              ))}
            </div>
            <div className="rounded-3xl overflow-hidden border border-black/5 h-[320px] bg-white">
              <iframe title="West Face Roofing location" data-testid="contact-map"
                src="https://www.google.com/maps?q=Coode%20Street%20South%20Perth%20WA%206151&output=embed"
                className="w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </div>
          <div id="quote">
            <QuoteForm />
          </div>
        </div>
      </section>
    </>
  );
}
